<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="nome"
              rules="required"
            >
              <b-form-group
                label="Nome"
                label-for="v-nome"
              >
                <b-form-input
                  id="v-nome"
                  v-model="form.nome"
                  :state="errors.length > 0 ? false : null"
                  placeholder="nome"
                  data-cy="nome-input"
                  :disabled="!canEditOrInsert"
                />
                <small
                  data-cy="v-nome-validate"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- first valor -->
          <b-col
            cols="12"
            md="6"
            lg="6"
          >
            <b-form-group
              label="Valor"
              label-for="v-valor"
            >
              <cleave
                id="v-valor"
                v-model.number="form.valor"
                class="form-control"
                :raw="true"
                :options="options.number"
                placeholder="valor"
                data-cy="valor-input"
                :disabled="!canEditOrInsert"
              />
            </b-form-group>
          </b-col>

          <!-- email -->
          <b-col
            cols="12"
            md="6"
            lg="6"
          >
            <validation-provider
              #default="{ errors }"
              name="Tipo de Atendimento"
              rules="required"
            >
              <b-form-group
                label="Tipo de Atendimento"
                label-for="v-tipoAtendimento"
              >
                <v-select
                  v-model="form.tipoAtendimento.id"
                  :reduce="(comboTiposAtendimento) => comboTiposAtendimento.id"
                  label="nome"
                  :options="comboTiposAtendimento"
                  :state="errors.length > 0 ? false : null"
                  data-cy="tipo-atendimento-select"
                  :disabled="!canEditOrInsert"
                />
                <small
                  data-cy="v-tipoAtendimento-validate"
                  class="text-danger"
                >{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- especialidades vinculadas -->
          <b-col cols="12">
            <b-form-group
              label="Especialidades Vinculadas (Visibilidade no Atendimento)"
              label-for="v-especialidadesVinculadas"
            >
              <v-select
                v-model="form.especialidadesVinculadas"
                multiple
                label="descricao"
                :options="comboEspecialidades"
                placeholder="Selecione as especialidades que este profissional também poderá visualizar"
                data-cy="especialidades-vinculadas"
                :disabled="
                  (!verificarPermissao('ROLE_ATEND_ATUALIZAR') && !!form.id) ||
                    (!verificarPermissao('ROLE_ATEND_INSERIR') && !form.id)
                "
              />
              <small
                class="text-muted"
              >Os procedimentos das especialidades selecionadas aqui serão
                exibidos no histórico durante o atendimento desta
                especialidade.</small>
            </b-form-group>
          </b-col>

          <b-col
            v-if="especialidade.id"
            cols="12"
          >
            <b-form-group>
              <b-form-checkbox
                v-model="form.ativo"
                :checked="form.ativo"
                name="check-button"
                switch
                inline
                data-cy="ativo-checkbox"
                :disabled="!canEditOrInsert"
              >
                {{ form.ativo ? "Sim" : "Não" }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <!-- submit and reset -->
          <ButtonsFormVue
            :permission-insert="canInsert"
            :permission-edit="canEdit"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import mixinsGlobal from '@/mixins'
import Cleave from 'vue-cleave-component'
import vSelect from 'vue-select'
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    Cleave,
    vSelect,
    ButtonsFormVue,
  },
  directives: {
    Ripple,
  },
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('combosModule', {
      comboTiposAtendimento: state => state.comboTiposAtendimento,
    }),
    ...mapState('especialidadeSettingsModule', {
      especialidade: state => state.especialidade,
      listaEspecialidades: state => state.listaEspecialidades,
    }),
    comboEspecialidades() {
      return this.listaEspecialidades.filter(e => e.id !== this.form.id)
    },
  },
  data() {
    return {
      titleForm: 'Cadastro de Especialidade',
      required,
      form: {
        nome: '',
        valor: 0,
        tipoAtendimento: {
          id: null,
        },
        ativo: true,
        especialidadesVinculadas: [],
      },
      options: {
        number: {
          numeral: true,
          numeralDecimalMark: ',',
          delimiter: '.',
        },
      },
      comboTipoAtendimento: [],
    }
  },
  async mounted() {
    this.form = JSON.parse(JSON.stringify(this.especialidade))
    await this.$store.dispatch('combosModule/loadComboTipoAtendimento')
    await this.$store.dispatch('especialidadeSettingsModule/loadAll')
  },
  methods: {
    cancel() {
      this.$emit('cancelar')
      this.cleanObjeto()
    },
    save() {
      this.$refs.form.validate().then(success => {
        if (success) {
          if (this.form.id) {
            this.$store
              .dispatch('especialidadeSettingsModule/edit', this.form)
              .then(response => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Editar',
                    response.response.data.error,
                  )
                  return
                }
                this.showMessageSuccess('Editar', 'Editado com sucesso!')
                this.$refs.form.reset()
                this.cancel()
              })
          } else {
            this.$store
              .dispatch('especialidadeSettingsModule/insert', this.form)
              .then(response => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Inserir',
                    response.response.data.error,
                  )
                  return
                }
                this.showMessageSuccess('Salvo', 'Incluido com sucesso!')
                this.cleanObjeto()
                this.$refs.form.reset()
              })
          }
        }
      })
    },
    cleanObjeto() {
      this.form = {
        nome: '',
        valor: 0,
        tipoAtendimento: {
          id: null,
        },
        ativo: true,
        especialidadesVinculadas: [],
      }
      this.$store.dispatch('especialidadeSettingsModule/reset')
    },
  },
}
</script>
